
export const config = {
  id: 'hologram',
  name: 'Hologram',
  icon: 'atom',
  color: 'cyan',
  welcomeMessage: "INITIALIZING HOLOGRAPHIC INTERFACE... Ready to assist.",
  typography: "'Share Tech Mono', monospace",
  description: 'A holographic visual style.',
  preview: 'PROCESSING REQUEST... Please stand by.',
  suggestedPrompts: [
    { text: 'Project data stream' },
    { text: 'Analyze query' },
    { text: 'Display schematics' },
  ],
  animation: {
    messageIn: 'message-appear',
    messageOut: 'message-fade',
    typing: 'hologram-typing',
    avatar: 'avatar-rotate',
    button: 'hologram-scan',
    grid: true,
    scanlines: true,
    noise: true
  },
  transitions: {
    duration: '0.5s',
    timing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    hover: '0.3s ease-in-out'
  },
  effects: {
    glow: 'shadow-lg shadow-cyan-400/50',
    hover: 'translateY(-2px)',
    focus: 'ring-2 ring-cyan-400',
    active: 'scale-95',
    grid: true,
    scanlines: true,
    noise: true,
    particles: true
  },
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "hologram",
  color: "#22D3EE",
  typography: "Share Tech Mono, monospace",
  welcomeMessage: "INITIALIZING HOLOGRAPHIC INTERFACE... Ready to assist.",
  userId: "user_holo_123",
  chatbotId: "bot_holo_001",
  animations: {
    enabled: true,
    duration: "0.5s",
    effects: {
      grid: true,
      scanlines: true,
      noise: true,
      particles: true
    }
  }
};
</script>`
}; 